module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', {
    staticClass: "filters-container",
    attrs: {
      "type": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1%"
    }
  }, [_c('countries-group', {
    attrs: {
      "filter": _vm.filters[1],
      "show-all-button": true
    },
    on: {
      "update-filter": _vm.updateFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar"
    },
    on: {
      "input": _vm.filtrando
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "span": 8
    }
  }, [(_vm.download_report_visible) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "data-cy": "generarReporte"
    },
    on: {
      "click": _vm.downloadProvidersData
    }
  }, [_vm._v("Generar Reporte")]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('data-tables', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "tablaReporteProveedores",
      "data": _vm.providersData,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    }
  }, _vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "width": "200",
        "align": title.align
      }
    })
  }), 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-body"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6471e90a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ReportTable.vue
// module id = 637
// module chunks = 1